// extracted by mini-css-extract-plugin
export default {"urlInput":"urlInput__Hzop4S","urlInputLabel":"urlInputLabel__QuOJ4B","urlInputButton":"urlInputButton__bU98cO","urlInputError":"urlInputError__mlOAQf"};